// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__6l71e","range":"MonthRangeSwitch_range__qdG_8","disabled":"MonthRangeSwitch_disabled__1hEnq"};